import { FormatMessageFunction } from '@common/types/Translation';
import { EMAIL_REGEX } from '@constants/common';
import * as Yup from 'yup';

export const createLoginValidationSchema = (formatMessage: FormatMessageFunction) =>
    Yup.object({
        email: Yup.string()
            .required(
                formatMessage(
                    {
                        id: 'schema.errors.required',
                        defaultMessage: '{field} is required',
                        description: 'Error message displayed when user leaves a mandatory field empty. Used in forms',
                    },
                    { field: formatMessage({ id: 'common.email', defaultMessage: 'Email' }) }
                )
            )
            .matches(
                EMAIL_REGEX,
                formatMessage(
                    {
                        id: 'schema.errors.invalid',
                        defaultMessage: '{field} is invalid',
                        description:
                            'Error message displayed when user enters a value that does not match the required format. Used in forms',
                    },
                    { field: formatMessage({ id: 'common.email', defaultMessage: 'Email' }) }
                )
            ),
        password: Yup.string().when('showPasswordField', {
            is: true,
            then: (schema) =>
                schema.required(
                    formatMessage(
                        {
                            id: 'schema.errors.required',
                            defaultMessage: '{field} is required',
                            description:
                                'Error message displayed when user leaves a mandatory field empty. Used in forms',
                        },
                        { field: formatMessage({ id: 'auth.fields.password.title', defaultMessage: 'Password' }) }
                    )
                ),
            otherwise: (schema) => schema,
        }),
        showPasswordField: Yup.boolean(),
    });
